<template>
  <el-radio-group :value="tbForm[key]" @change.native="onChange">
    <el-radio
      v-for="item in options"
      :label="item.value"
      :key="item.value"
    >{{item.displayName}}
      <el-tooltip
        v-if="item.warning"
        class="item"
        effect="dark"
        :content="item.warning"
        placement="top">
        <i style="margin-left: 5px; margin-right: 5px;" class="el-icon-warning" />
      </el-tooltip>
    </el-radio>
  </el-radio-group>
</template>

<script>
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins],
  props: ['props', 'isSizeGroup'],
  data() {
    return {
      isHasOptionsComp: true,
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    defaultValue() {
      return this.props.dataSource.defaultValue;
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v.target.value
      this.updateTbForm(newFormFields)
      this.$emit('change', v)
    },
    getOptions(){
      return this.options
    }
  },
  updated() {
    // 处理返回数据不在可选项的情况
    if (this.tbForm[this.key]) {
      if (!this.options.find(item => item.value === this.tbForm[this.key])) {
        this.onChange({target: {value: ''}})
      }
    }
    // // 处理库存计数后端返回数据不在可选项的情况
    // if (this.key === 'subStock') {
    //   if (!this.options.find(item => item.value === String(this.tbForm[this.key]))) {
    //     this.onChange({target: {value: ''}})
    //     console.log('====subStock==')
    //   }
    // }
    if (this.isSizeGroup) {
      if (!this.options.find(item => item.value === this.tbForm[this.key])) {
        const commonSize = this.options.find(item => ['通用', '均码'].includes(item.displayName)) || this.options[0];
        commonSize && this.onChange({target: commonSize})
      }
    }
  }
};
</script>